function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    id: "Image",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56,17h4v36H37   c-0.553,0-1,0.448-1,1c0,1.104-0.896,2-2,2h-4c-1.104,0-2-0.896-2-2c0-0.552-0.447-1-1-1H4V17h4",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,17   c5.071-5.724,12.353-9,20-9v34c-7.647,0-14.929,3.276-20,9c-5.071-5.724-12.353-9-20-9V8C19.647,8,26.929,11.276,32,17z",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13.14   C10.67,13.04,9.34,13,8,13v4v30c8.26,0,16.43,1.7,24,5c7.57-3.3,15.74-5,24-5V17v-4c-1.34,0-2.67,0.04-4,0.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 32,
    x2: 32,
    y1: 17,
    y2: 51
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M46,15.48c-3.59,0.68-6.99,2.09-10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M18,15.48c3.59,0.68,6.99,2.09,10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M46,20.45c-3.59,0.68-6.99,2.09-10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M18,20.45c3.59,0.68,6.99,2.09,10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M46,25.42c-3.59,0.68-6.99,2.09-10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M18,25.42c3.59,0.68,6.99,2.09,10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M46,30.39c-3.59,0.68-6.99,2.09-10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M18,30.39c3.59,0.68,6.99,2.09,10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M46,35.36c-3.59,0.68-6.99,2.09-10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M18,35.36c3.59,0.68,6.99,2.09,10,4.14",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.731c4fe372365f2a8d10c0ee1665be5f.svg";
export { ForwardRef as ReactComponent };